export default __webpack_public_path__ + "static/NeoSansPro-Regular-e1b2bba3dc77e7bea1663f007601f344.woff";